<div class="py-2 sm:py-6">
  <div class="px-4 sm:px-6 lg:px-8">
    <!-- Header Section -->
    <div class="text-center mb-6 sm:mb-8">
      <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">{{ 'Wybierz sposób składania zamówienia' | translate }}</h2>
      <p class="text-sm sm:text-base text-gray-500 mt-1 max-w-xl mx-auto">
        {{ 'Zaloguj się, utwórz konto lub złóż zamówienie bez rejestracji.' | translate }}
      </p>
    </div>
    
    <!-- Already Logged In Message -->
    <div *ngIf="checkAuthenticationStatus()" class="text-center p-6 bg-green-50/80 border border-green-200 rounded-xl mb-6">
      <div class="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 text-green-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
        </svg>
      </div>
      <h3 class="text-lg font-bold text-green-900 mb-1">{{ 'Witaj ponownie!' | translate }}</h3>
      <p class="text-sm text-green-700 mb-2">{{ 'Zalogowano jako' | translate }} <span translate="no" class="notranslate font-semibold">{{ authService.getCurrentUser()?.email }}</span></p>
      <p class="text-xs text-green-600">{{ 'Przechodzimy do danych rozliczeniowych…' | translate }}</p>
    </div>
    
    <!-- Options Grid -->
    <div *ngIf="!checkAuthenticationStatus()" class="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8" role="radiogroup" [attr.aria-label]="'Sposób składania zamówienia' | translate">
      <!-- 1. Login Option -->
      <div 
        role="radio"
        [attr.aria-checked]="selectedOption === 'login'"
        [attr.tabindex]="selectedOption === 'login' ? 0 : -1"
        aria-labelledby="checkout-login-title"
        (keydown)="handleOptionKeydown($event, 'login')"
        class="relative bg-white rounded-xl p-5 sm:p-6 border transition-all cursor-pointer shadow-sm hover:border-gray-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2"
        [class.border-brocom-orange]="selectedOption === 'login'"
        [class.ring-1]="selectedOption === 'login'"
        [class.ring-brocom-orange]="selectedOption === 'login'"
        [class.bg-orange-50]="selectedOption === 'login'"
        [class.border-gray-200]="selectedOption !== 'login'"
        (click)="selectOption('login')"
      >
        <!-- Selection Radio -->
        <div class="absolute top-5 right-5">
          <div 
            class="w-5 h-5 rounded-full border flex items-center justify-center transition-colors"
            [class.border-brocom-orange]="selectedOption === 'login'"
            [class.bg-brocom-orange]="selectedOption === 'login'"
            [class.border-gray-300]="selectedOption !== 'login'"
          >
            <svg 
              *ngIf="selectedOption === 'login'"
              class="w-3 h-3 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>

        <!-- Icon -->
        <div class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mb-4 text-gray-700">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>

        <!-- Content -->
        <h3 id="checkout-login-title" class="text-base font-bold text-gray-900 mb-1">{{ 'Zaloguj się' | translate }}</h3>
        <p class="text-xs text-gray-500 mb-4">
          {{ 'Dla klientów firmowych i indywidualnych posiadających konto' | translate }}
        </p>

        <!-- Features -->
        <div class="space-y-2 text-xs text-gray-600 border-t border-gray-100 pt-3">
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Dane z profilu mogą automatycznie uzupełnić formularz zamówienia' | translate }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Zapisane dane firmy mogą uzupełnić dane do faktury' | translate }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Historia zamówień i śledzenie przesyłek' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- 2. Registration Option -->
      <div 
        role="radio"
        [attr.aria-checked]="selectedOption === 'register'"
        [attr.tabindex]="selectedOption === 'register' ? 0 : -1"
        aria-labelledby="checkout-register-title"
        (keydown)="handleOptionKeydown($event, 'register')"
        class="relative bg-white rounded-xl p-5 sm:p-6 border transition-all cursor-pointer shadow-sm hover:border-gray-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2"
        [class.border-brocom-orange]="selectedOption === 'register'"
        [class.ring-1]="selectedOption === 'register'"
        [class.ring-brocom-orange]="selectedOption === 'register'"
        [class.bg-orange-50]="selectedOption === 'register'"
        [class.border-gray-200]="selectedOption !== 'register'"
        (click)="selectOption('register')"
      >
        <!-- Selection Radio -->
        <div class="absolute top-5 right-5">
          <div 
            class="w-5 h-5 rounded-full border flex items-center justify-center transition-colors"
            [class.border-brocom-orange]="selectedOption === 'register'"
            [class.bg-brocom-orange]="selectedOption === 'register'"
            [class.border-gray-300]="selectedOption !== 'register'"
          >
            <svg 
              *ngIf="selectedOption === 'register'"
              class="w-3 h-3 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>

        <!-- Icon -->
        <div class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mb-4 text-gray-700">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
          </svg>
        </div>

        <!-- Content -->
        <div class="flex items-center gap-2 mb-1">
          <h3 id="checkout-register-title" class="text-base font-bold text-gray-900">{{ 'Utwórz bezpłatne konto' | translate }}</h3>
          <span class="rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-orange-700">
            {{ 'Polecamy' | translate }}
          </span>
        </div>
        <p class="text-xs text-gray-500 mb-4">
          {{ 'Zapisz dane, aby szybciej składać kolejne zamówienia i wygodnie zarządzać adresami oraz historią zakupów.' | translate }}
        </p>

        <!-- Features -->
        <div class="space-y-2 text-xs text-gray-600 border-t border-gray-100 pt-3">
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Zapisane dane profilu mogą uzupełnić formularz zamówienia' | translate }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Przeglądaj historię zamówień i śledź przesyłki' | translate }}</span>
          </div>
        </div>
        <p class="mt-4 border-t border-gray-100 pt-3 text-xs leading-relaxed text-gray-500">
          {{ 'Utworzenie konta zajmie kilka chwil. Potwierdź adres e-mail, a następnie zaloguj się, aby kontynuować zakupy.' | translate }}
        </p>
      </div>

      <!-- 3. Without Login (Guest) -->
      <div 
        role="radio"
        [attr.aria-checked]="selectedOption === 'guest'"
        [attr.tabindex]="selectedOption === 'guest' ? 0 : -1"
        aria-labelledby="checkout-guest-title"
        (keydown)="handleOptionKeydown($event, 'guest')"
        class="relative bg-white rounded-xl p-5 sm:p-6 border transition-all cursor-pointer shadow-sm hover:border-gray-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2"
        [class.border-brocom-orange]="selectedOption === 'guest'"
        [class.ring-1]="selectedOption === 'guest'"
        [class.ring-brocom-orange]="selectedOption === 'guest'"
        [class.bg-orange-50]="selectedOption === 'guest'"
        [class.border-gray-200]="selectedOption !== 'guest'"
        (click)="selectOption('guest')"
      >
        <!-- Selection Radio -->
        <div class="absolute top-5 right-5">
          <div 
            class="w-5 h-5 rounded-full border flex items-center justify-center transition-colors"
            [class.border-brocom-orange]="selectedOption === 'guest'"
            [class.bg-brocom-orange]="selectedOption === 'guest'"
            [class.border-gray-300]="selectedOption !== 'guest'"
          >
            <svg 
              *ngIf="selectedOption === 'guest'"
              class="w-3 h-3 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>

        <!-- Icon -->
        <div class="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mb-4 text-gray-700">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
        </div>

        <!-- Content -->
        <h3 id="checkout-guest-title" class="text-base font-bold text-gray-900 mb-1">{{ 'Zakup bez rejestracji' | translate }}</h3>
        <p class="text-xs text-gray-500 mb-4">
          {{ 'Złóż zamówienie bez tworzenia konta i hasła.' | translate }}
        </p>

        <!-- Features -->
        <div class="space-y-2 text-xs text-gray-600 border-t border-gray-100 pt-3">
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Nie musisz tworzyć hasła' | translate }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Prosty proces składania zamówienia' | translate }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-3.5 h-3.5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <span>{{ 'Potwierdzenie zamówienia e-mailem' | translate }}</span>
          </div>
        </div>
        <p class="mt-4 border-t border-gray-100 pt-3 text-xs leading-relaxed text-gray-500">
          {{ 'Chcesz zapisać dane na przyszłość? Możesz utworzyć bezpłatne konto.' | translate }}
        </p>
      </div>
    </div>

    <!-- Login Form (shown when login is selected) -->
    <div 
      id="checkout-login-panel"
      *ngIf="selectedOption === 'login'" 
      class="bg-white rounded-xl p-5 sm:p-7 border border-gray-200 shadow-sm max-w-lg mx-auto"
    >
      <div class="mb-6">
        <h3 class="text-xl font-semibold tracking-tight text-gray-900">{{ 'Zaloguj się na swoje konto' | translate }}</h3>
        <p class="mt-1 text-sm text-gray-500">{{ 'Zaloguj się, aby kontynuować składanie zamówienia.' | translate }}</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" class="space-y-5">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1.5">
            {{ 'Adres e-mail' | translate }}
          </label>
          <div class="relative">
            <input
              type="email"
              id="email"
              formControlName="email"
              autocomplete="email"
              class="w-full h-12 px-4 pr-11 bg-gray-50 border rounded-lg text-sm text-gray-900 placeholder:text-gray-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brocom-orange/20 focus:border-brocom-orange transition-colors"
              [class.border-red-500]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
              [class.border-gray-200]="!loginForm.get('email')?.invalid || !loginForm.get('email')?.touched"
              [placeholder]="'name@company.com' | translate"
            />
            <svg aria-hidden="true" class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 018 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"></path>
            </svg>
          </div>
          <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="mt-1 text-sm text-red-600">
            <span *ngIf="loginForm.get('email')?.errors?.['required']">{{ 'Adres e-mail jest wymagany.' | translate }}</span>
            <span *ngIf="loginForm.get('email')?.errors?.['email']">{{ 'Wpisz prawidłowy adres e-mail.' | translate }}</span>
          </div>
        </div>
        
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1.5">
            {{ 'Hasło' | translate }}
          </label>
          <div class="relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              autocomplete="current-password"
              class="w-full h-12 px-4 pr-12 bg-gray-50 border rounded-lg text-sm text-gray-900 placeholder:text-gray-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brocom-orange/20 focus:border-brocom-orange transition-colors"
              [class.border-red-500]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
              [class.border-gray-200]="!loginForm.get('password')?.invalid || !loginForm.get('password')?.touched"
              [placeholder]="'Wpisz hasło' | translate"
            />
            <button
              type="button"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Ukryj hasło' : 'Pokaż hasło'"
              class="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange rounded-md transition-colors"
            >
              <svg *ngIf="!showPassword" aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
              </svg>
              <svg *ngIf="showPassword" aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"></path>
              </svg>
            </button>
          </div>
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="mt-1 text-sm text-red-600">
            <span *ngIf="loginForm.get('password')?.errors?.['required']">{{ 'Hasło jest wymagane.' | translate }}</span>
            <span *ngIf="loginForm.get('password')?.errors?.['minlength']">{{ 'Hasło musi mieć co najmniej 6 znaków.' | translate }}</span>
          </div>
        </div>
        
        <div class="flex items-center justify-between">
          <label class="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              formControlName="rememberMe"
              class="w-4 h-4 accent-brocom-orange rounded border-gray-300 focus:ring-brocom-orange"
            >
            <span class="text-sm text-gray-600">{{ 'Zapamiętaj mnie' | translate }}</span>
          </label>
          <button
            type="button"
            (click)="showForgotPassword()"
            class="text-sm font-medium text-brocom-orange hover:text-orange-700 focus-visible:outline-none focus-visible:underline transition-colors"
          >
            {{ 'Nie pamiętasz hasła?' | translate }}
          </button>
        </div>

        <!-- Login Error Message -->
        <div *ngIf="loginError" role="alert" class="bg-red-50 border border-red-200 rounded-lg p-4">
          <div class="flex items-center">
            <svg class="w-5 h-5 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span class="text-red-700 text-sm">{{ loginError }}</span>
          </div>
        </div>
      </form>

      <!-- Forgot Password Modal/Section -->
      <div 
        *ngIf="showForgotPasswordForm" 
        class="mt-5 p-4 sm:p-5 bg-gray-50 border border-gray-200 rounded-xl animate-fadeIn"
      >
        <div class="flex items-center justify-between mb-4">
          <h4 class="text-base font-semibold text-gray-900 flex items-center gap-2">
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
            {{ 'Resetowanie hasła' | translate }}
          </h4>
          <button
            type="button"
            (click)="hideForgotPassword()"
            class="p-1 text-gray-400 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange rounded-md transition-colors"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <p class="text-sm text-gray-600 mb-4">
          {{ 'Podaj adres e-mail, a wyślemy Ci link do zresetowania hasła.' | translate }}
        </p>
        
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()" class="space-y-4">
          <div>
            <label for="forgotEmail" class="block text-sm font-medium text-gray-700 mb-2">
              {{ 'Adres e-mail' | translate }}
            </label>
            <div class="relative">
              <input
                type="email"
                id="forgotEmail"
                formControlName="email"
                class="w-full h-12 px-4 bg-white border rounded-lg text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brocom-orange/20 focus:border-brocom-orange transition-colors"
                [class.border-red-500]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched"
                [class.border-gray-200]="!forgotPasswordForm.get('email')?.invalid || !forgotPasswordForm.get('email')?.touched"
                [placeholder]="'Wpisz adres e-mail' | translate"
              />
              <svg class="absolute right-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"></path>
              </svg>
            </div>
            <div *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" class="mt-1 text-sm text-red-600">
              <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">{{ 'Adres e-mail jest wymagany.' | translate }}</span>
              <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">{{ 'Wpisz prawidłowy adres e-mail.' | translate }}</span>
            </div>
          </div>
          
          <!-- Success Message -->
          <div *ngIf="forgotPasswordSuccess" role="status" class="bg-green-50 border border-green-200 rounded-lg p-4">
            <div class="flex items-center">
              <svg class="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span class="text-green-700 text-sm">{{ 'Link do resetowania hasła został wysłany. Sprawdź pocztę.' | translate }}</span>
            </div>
          </div>
          
          <!-- Error Message -->
          <div *ngIf="forgotPasswordError" role="alert" class="bg-red-50 border border-red-200 rounded-lg p-4">
            <div class="flex items-center">
              <svg class="w-5 h-5 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span class="text-red-700 text-sm">{{ forgotPasswordError }}</span>
            </div>
          </div>
          
          <div class="flex gap-3">
            <button
              type="submit"
              [disabled]="forgotPasswordForm.invalid || isSendingReset"
              class="flex-1 bg-brocom-orange text-white py-3 px-4 rounded-lg font-medium hover:bg-orange-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
            >
              <span *ngIf="!isSendingReset">{{ 'Wyślij link do resetowania' | translate }}</span>
              <div *ngIf="isSendingReset" class="flex items-center space-x-2">
                <svg class="animate-spin w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                <span>{{ 'Wysyłanie…' | translate }}</span>
              </div>
            </button>
            <button
              type="button"
              (click)="hideForgotPassword()"
              class="px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              {{ 'Cancel' | translate }}
            </button>
          </div>
        </form>
      </div>

    </div>

    <!-- Already Logged In Message -->
    <div *ngIf="checkAuthenticationStatus()" class="text-center p-8 bg-green-50 border border-green-200 rounded-3xl mb-6">
      <div class="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-8 h-8 text-green-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
        </svg>
      </div>
      <h3 class="text-xl font-bold text-green-800 mb-2">{{ 'Witaj ponownie!' | translate }}</h3>
      <p class="text-green-700 mb-4">{{ 'Zalogowano jako' | translate }} <span translate="no" class="notranslate font-semibold">{{ authService.getCurrentUser()?.email }}</span></p>
      <p class="text-sm text-green-600">{{ 'Przechodzimy do kolejnego etapu…' | translate }}</p>
    </div>

    <!-- Action Buttons -->
    <div class="text-center mt-6 sm:mt-8 px-4">
      <button
        *ngIf="selectedOption === 'guest'"
        (click)="continueAsGuest()"
        class="w-full sm:w-auto bg-brocom-orange text-white px-8 sm:px-12 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-brocom-orange-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 transition-colors duration-150 shadow-sm flex items-center justify-center mx-auto"
      >
        <span>{{ 'Kontynuuj jako gość' | translate }}</span>
        <svg class="w-5 h-5 sm:w-6 sm:h-6 ml-2 sm:ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </button>
      
      <button
        *ngIf="selectedOption === 'login'"
        (click)="onLoginSubmit()"
        [disabled]="loginForm.invalid || isLoggingIn"
        class="w-full sm:w-auto bg-brocom-orange text-white px-8 sm:px-12 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-brocom-orange-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 transition-colors duration-150 shadow-sm flex items-center justify-center mx-auto disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span *ngIf="!isLoggingIn" class="flex items-center space-x-2">
          <span>{{ 'Zaloguj się' | translate }}</span>
          <span>{{ '&amp;' | translate }}</span>
          <span>{{ 'Kontynuuj' | translate }}</span>
        </span>
        <span *ngIf="isLoggingIn" class="flex items-center space-x-2">
          <svg class="animate-spin w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
          </svg>
          <span>{{ 'Logowanie…' | translate }}</span>
        </span>
        <svg *ngIf="!isLoggingIn" class="w-5 h-5 sm:w-6 sm:h-6 ml-2 sm:ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </button>

      <button
        *ngIf="selectedOption === 'register'"
        (click)="continueWithRegistration()"
        class="w-full sm:w-auto bg-brocom-orange text-white px-8 sm:px-12 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-brocom-orange-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 transition-colors duration-150 shadow-sm flex items-center justify-center mx-auto"
      >
        <span>{{ 'Utwórz konto' | translate }}</span>
        <svg class="w-5 h-5 sm:w-6 sm:h-6 ml-2 sm:ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </button>

      <!-- Security Badge -->
      <div class="mt-8 flex items-center justify-center space-x-2 text-gray-500">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
        <span class="text-sm">{{ 'Twoje dane są bezpieczne i szyfrowane' | translate }}</span>
      </div>
    </div>
  </div>
</div>
